import * as basicScroll from 'basicscroll';

export const fadeIn = () => ({
  '--opacity': {
    from: 0.01,
    to: 0.99,
  },
})

export const parallax = (from, to) => ({
  '--translateY': {
    from: `${from}%`,
    to: `${to}%`,
  },
})

export const fadeInParallax = (from, to) => ({
  '--opacity': {
    from: 0.01,
    to: 0.99,
  },
  '--translateY': {
    from: `${from}%`,
    to: `${to}%`,
  },
})

export const scale = (from, to) => ({
  '--scale': {
    from: `${from}%`,
    to: `${to}%`,
  },
})

export class Parallax {
  constructor() {
    this.elems = [...document.querySelectorAll('.js-element')]
    this.instances = null

    this.init()
  }

  animations() {
    this.instances = []
    this.elems.forEach((el) => {
      /* eslint-disable */
      const props = eval(el.dataset.animation)
      /* eslint-enable */

      const instance = basicScroll.create({
        elem: el,
        from: el.dataset.from,
        to: el.dataset.to,
        direct: true,
        props,
      })

      this.instances.push(instance)
    })
  }

  run() {
    this.instances.forEach((instance) => {
      instance.start()
    })
  }

  resize() {
    this.instances.forEach((instance) => {
      instance.calculate()
      instance.update()
    })
  }

  init() {
    this.animations()
    this.run()

    window.addEventListener('resize', this.resize.bind(this), false)
  }
}
